// Space used in chart states as bottom margin
export const BRUSH_BOTTOM_SPACE = 75;
